<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-4 col-xl-3 col-md-3">
                <router-link :to="{name: 'offer_step1'}" class="btn btn-block btn-success m-b-20">
                    <i class="fas fa-hand-holding-usd m-r-10"></i> Post a New Offer
                </router-link>
                <form>
                    <div class="input-group mb-3">
                        <div class="input-group-prepend">
                            <span class="input-group-text"><i class="ti-search"></i></span>
                        </div>
                        <input aria-label="Amount (to the nearest dollar)" class="form-control"
                               placeholder="Search Contacts Here..." type="text">
                        <div class="input-group-append">
                            <button class="btn btn-success">Ok</button>
                        </div>
                    </div>
                </form>
                <div class="list-group m-t-30">
                    <router-link class="list-group-item" :to="{name: 'alloffers'}"><i class="ti-layers m-r-10"></i> All Offers</router-link>
                    <a class="list-group-item active" href="javascript:void(0)"><i class="ti-star m-r-10"></i> My Offers</a>
                    <a class="list-group-item" href="javascript:void(0)"><i class="ti-bookmark m-r-10"></i> Recently
                        Created</a>
                </div>
            </div>



            <div class="col-lg-8 col-xl-9 col-md-9">

                <div class="alert alert-info text-center alert-rounded" v-if="offers.length === 0">
                    <i class="ti-alert"></i> No offers were found. Please create a new offer.
                </div>

                <div class="card" v-bind:key="index" v-for="(offer,index) in offers">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-6">
                                <h3 class="font-bold m-b-xs">{{offer.commodity_name}}</h3>
                                <div>{{offer.name}}</div>
                            </div>
                            <div class="col-md-6">
                                <div class="btn-group float-right">
                                    <button aria-expanded="false" aria-haspopup="true"
                                            class="btn btn-light dropdown-toggle" data-toggle="dropdown" type="button">
                                        Action
                                    </button>
                                    <div class="dropdown-menu">
                                        <router-link :to="{name: 'viewoffer', params: {offerid: offer.offer_id}}"
                                                     class="dropdown-item">
                                            View Offer
                                        </router-link>
                                        <a @click="setOffer(offer)" class="dropdown-item"
                                           data-target="#contractOverview"
                                           data-toggle="modal" href="javascript:void(0)">
                                            Edit Offer
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <hr>
                                <div>
                                    <h4 class="product-main-price">{{formatQuantity(offer.quantity, offer.unit.symbol)}}
                                        <i class="fas fa-at"></i> {{offer.unit_price | money}}</h4>
                                </div>
                                <div class="">
                                    <br>
                                    {{offer.description}}
                                </div>
                                <dl class="row m-t-md">
                                    <dt class="col-md-4 text-right">Contract Type</dt>
                                    <dd class="col-md-8">{{offer.contract_type | capitalize}}</dd>
                                    <dt class="col-md-4 text-right">Offer Type</dt>
                                    <dd class="col-md-8">{{offer.type | capitalize}}</dd>
                                    <dt class="col-md-4 text-right">Pricing Type</dt>
                                    <dd class="col-md-8">{{offer.category | capitalize}}</dd>
                                    <dt class="col-md-4 text-right">Quantity</dt>
                                    <dd class="col-md-8">{{offer.quantity | count}} {{offer.unit.symbol}}</dd>
                                    <dt class="col-md-4 text-right">Unit Price</dt>
                                    <dd class="col-md-8">{{(offer.unit_price) | money}}</dd>
                                    <dt class="col-md-4 text-right" v-if="offer.commodity_props">Grade</dt>
                                    <dd class="col-md-8" v-if="offer.commodity_props">{{offer.commodity_props['grade']}}</dd>
                                    <dt class="col-md-4 text-right">Speciality</dt>
                                    <dd class="col-md-8">{{offer.offer_props['commodity_speciality'].join(', ')}}</dd>
                                    <dt class="col-md-4 text-right">Harvest Year</dt>
                                    <dd class="col-md-8">{{offer.harvest_year}}</dd>
                                    <dt class="col-md-4 text-right">Created on</dt>
                                    <dd class="col-md-8">{{offer.created_at | date}}</dd>
                                    <dt class="col-md-4 text-right">Expires on</dt>
                                    <dd class="col-md-8">{{offer.expires_at | date}}</dd>
                                    <dt class="col-md-4 text-right" v-if="offer.contract_type === 'FORWARD'">Maturation
                                        date
                                    </dt>
                                    <dd class="col-md-8" v-if="offer.contract_type === 'FORWARD'">
                                        {{offer.maturation_date | date}}
                                    </dd>
                                    <dt class="col-md-4 text-right">Provenance</dt>
                                    <dd class="col-md-8" v-if="offer.provenance"><a :href="offer.provenance"
                                                                                    target="_blank">{{
                                        offer.provenance }}</a></dd>
                                    <dd class="col-md-8" v-else>NA</dd>
                                    <dt class="col-md-4 text-right">Audit</dt>
                                    <dd class="col-md-8" v-if="offer.audit"><a :href="offer.audit" target="_blank">{{
                                        offer.audit }}</a></dd>
                                    <dd class="col-md-8" v-else>NA</dd>
                                </dl>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div aria-labelledby="contractOverview" class="modal fade" id="contractOverview" role="dialog" tabindex="-1">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-body card-blue">
                        <div class="card-body">
                            <h4 class="card-title">Update Trade</h4>
                            <h5 class="card-subtitle">Change trade quantity and unit price</h5>
                            <!-- Tab panes -->
                            <div class="tab-content">
                                <div class="tab-pane active" id="properties" role="tabpanel">
                                    <div class="row m-t-20">
                                        <div class="col-md-12">
                                            <form>
                                                <div class="col-sm-12 col-lg-12 m-t-20">
                                                    <div class="form-group row">
                                                        <label class="text-right col-sm-2 control-label col-form-label">Quantity</label>
                                                        <div class="input-group col-sm-8">
                                                            <input class="form-control"
                                                                   data-vv-as="Provenance"
                                                                   name="provenance"
                                                                   placeholder="Trade Quantity"
                                                                   style="width: calc(100% - 70px); height: 42px;"
                                                                   type="number"
                                                                   v-model="update_offer.quantity"
                                                                   v-validate="">
                                                            <input :value="update_offer.unit.symbol"
                                                                   class="form-control"
                                                                   disabled>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-sm-12 col-lg-12 m-t-20">
                                                    <div class="form-group row">
                                                        <label class="text-right col-sm-2 control-label col-form-label">Unit
                                                            Price</label>
                                                        <div class="input-group col-sm-8">
                                                            <input class="form-control"
                                                                   data-vv-as="Provenance"
                                                                   name="provenance"
                                                                   placeholder="Unit Price"
                                                                   style="width: calc(100% - 80px); height: 42px;"
                                                                   type="number"
                                                                   v-model="update_offer.unit_price.amount"
                                                                   v-validate="">
                                                            <input :value="update_offer.unit_price.currency_symbol+'/'+update_offer.unit.symbol"
                                                                   class="form-control"
                                                                   disabled>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-sm-12 col-lg-12 m-t-20">
                                                    <div class="form-group row">
                                                        <label class="text-right col-sm-2 control-label col-form-label">Provenance</label>
                                                        <div class="input-group col-sm-8">
                                                            <input class="form-control"
                                                                   data-vv-as="Provenance"
                                                                   name="provenance"
                                                                   placeholder="Provenance"
                                                                   style="height: 42px;"
                                                                   type="text"
                                                                   v-model="update_offer.provenance"
                                                                   v-validate="">
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-sm-12 col-lg-12 m-t-20">
                                                    <div class="form-group row">
                                                        <label class="text-right col-sm-2 control-label col-form-label">Audit</label>
                                                        <div class="input-group col-sm-8">
                                                            <input class="form-control"
                                                                   data-vv-as="Audit"
                                                                   name="audit"
                                                                   placeholder="Audit"
                                                                   style="height: 42px;"
                                                                   type="text"
                                                                   v-model="update_offer.audit"
                                                                   v-validate="">
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="modal-footer">
                        <button @click="update" class="btn waves-effect waves-light btn-success" data-dismiss="modal"
                                type="submit">Submit
                        </button>
                        <button @click="reset" class="btn waves-effect waves-light btn-secondary" type="button">Reset
                        </button>
                        <button class="btn waves-effect waves-light btn-danger" data-dismiss="modal" type="button">
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from "moment";
    import {BigNumber} from "bignumber.js";
    import {mapGetters} from "vuex";

    export default {
        name: "AllOffers",
        data() {
            return {
                statuses: [
                    "CREATED",
                    "ACTIVE",
                    "INACTIVE",
                    "NEGOTIATING",
                    "PENDING",
                    "CONFIRMED",
                    "SETTLED"
                ],
                offers: [],
                filters: {
                    commodity: "",
                    fromDate: "",
                    toDate: "",
                    fromAmount: "",
                    toAmount: "",
                    status: []
                },
                commodities: [],
                update_offer: {
                    offer_id: null,
                    unit: {
                        "id": null,
                        "name": null,
                        "symbol": null,
                        "base_unit": null
                    },
                    quantity: null,
                    unit_price: {
                        "amount": null,
                        "currency_id": null,
                        "currency_name": null,
                        "currency_symbol": null
                    },
                    provenance: null,
                    audit: null
                }
            };
        },
        computed: {
            ...mapGetters(["currentUser", "currentOrg"]),
            selectAll: {
                get: function () {
                    return this.statuses
                        ? this.filters.status.length === this.statuses.length
                        : false;
                },
                set: function (value) {
                    let selected = [];

                    if (value) {
                        this.statuses.forEach(function (status) {
                            selected.push(status);
                        });
                    }

                    this.filters.status = selected;
                }
            }
        },
        mounted: function () {
            this.getMyOffers();
        },
        methods: {
            check: function (e) {
                if (e.target.checked) {
                    this.filters.status = e.target.value;
                }
            },
            getMyOffers() {
                let query = $.param(this.filters);
                $(".preloader").fadeIn();
                this.$http
                    .get(`/marketplaces/${this.currentOrg.marketplace_id}/offers/my?${query}`)
                    .then(reply => {
                        $(".preloader").fadeOut();
                        this.offers = reply.data;
                        if (this.offers.length > 0) {
                            this.selectedOffer = this.offers[0];
                        } else {
                            this.selectedOffer = null;
                        }
                        this.init();
                    })
                    .catch(err => {
                        $(".preloader").fadeOut();
                        this.submitFailed(err)
                    });
            },
            formatDate(dateString) {
                const date = new Date(dateString);
                var day = date.getDate();
                var monthIndex = date.getMonth();
                var year = date.getFullYear();
                return monthIndex + 1 + "/" + day + "/" + year;
            },
            prepareChartData(datefrom, dateto) {
                const from = new Date(datefrom);
                const to = new Date(dateto);
                const now = new Date();
                let timeGap = (to.getTime() - from.getTime()) / (24 * 3600 * 1000);
                timeGap = Math.ceil(timeGap);
                let timeRemaining = (to.getTime() - now.getTime()) / (24 * 3600 * 1000);
                timeRemaining = Math.ceil(timeRemaining > 0 ? timeRemaining : 0);
                const chartData = timeGap - timeRemaining + "," + timeRemaining;
                return chartData;
            },
            fromNow(aDate) {
                return moment(aDate).fromNow();
            },
            formatQuantity(quantity, unit_symbol) {
                return new BigNumber(quantity).toFormat(2) + " " + (unit_symbol || "KG");
            },
            newOffer() {
                this.$router.push('/offers/new/step1');
            },
            init() {
                $(function () {
                    $("span.pie").peity("pie", {
                        fill: ["#1ab394", "#d7d7d7", "#ffffff"]
                    });

                    $(".line").peity("line", {
                        fill: "#1ab394",
                        stroke: "#169c81"
                    });

                    $(".bar").peity("bar", {
                        fill: ["#1ab394", "#d7d7d7"]
                    });

                    $(".bar_dashboard").peity("bar", {
                        fill: ["#1ab394", "#d7d7d7"],
                        width: 100
                    });

                    var updatingChart = $(".updating-chart").peity("line", {
                        fill: "#1ab394",
                        stroke: "#169c81",
                        width: 64
                    });

                    setInterval(function () {
                        var random = Math.round(Math.random() * 10);
                        var values = updatingChart.text().split(",");
                        values.shift();
                        values.push(random);

                        updatingChart.text(values.join(",")).change();
                    }, 1000);
                });

                $(".input-group.date").datepicker({
                    keyboardNavigation: false,
                    forceParse: false,
                    autoclose: true
                });
            },
            setOffer(offer) {
                this.update_offer = offer ? offer : this.update_offer;
                this.update_offer.quantity = offer ? Number(offer.quantity).toFixed(2) : this.update_offer.quantity
            },
            async update() {
                if (this.update_offer) {
                    try {
                        await this.$http.put(`/marketplaces/${this.currentOrg.marketplace_id}/offers/${this.update_offer.offer_id}`, this.update_offer);
                        await this.getMyOffers();
                    } catch (e) {

                    }
                }
            },
            reset() {
                this.update_offer = {
                    unit_id: null,
                    quantity: null,
                    unit_price: null
                }
            }
        }
    };
</script>

<style scoped>

</style>
